import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** 100dvh minus header (3.5rem) minus page padding p-2 (1rem). */
export const SETTINGS_PAGE_HEIGHT_CLASS = 'h-[calc(100dvh-3.5rem-1rem)]';

interface SettingsListDetailLayoutProps {
  list: ReactNode;
  detail: ReactNode;
  detailOpen?: boolean;
  detailVariant?: 'default' | 'wide';
}

/**
 * Master/detail shell for the settings pages. The detail pane is unmounted
 * while nothing is selected so the list can use the full width.
 */
export function SettingsListDetailLayout({
  list,
  detail,
  detailOpen = false,
  detailVariant = 'default',
}: SettingsListDetailLayoutProps) {
  return (
    <div className={cn('flex min-h-0 gap-0', SETTINGS_PAGE_HEIGHT_CLASS)}>
      <div className={cn('flex min-w-0 flex-1 flex-col overflow-hidden', detailOpen && 'pr-4')}>
        {list}
      </div>
      {detailOpen ? (
        <aside
          className={cn(
            'flex shrink-0 flex-col overflow-hidden border-l border-border-default bg-white',
            detailVariant === 'wide'
              ? 'min-w-[500px] w-3/5 max-w-[800px]'
              : 'w-[400px] min-w-[400px]'
          )}
        >
          {detail}
        </aside>
      ) : null}
    </div>
  );
}
